import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

type favoriteInfo = {
  favoriteName: string
  folderName: string
}

export function FavoriteModal() {
  const navigate = useNavigate()
  const closeModal = useAppStore.use.closeModal()
  const openModal = useAppStore.use.openModal()
  const { favoriteInfo, setFavoriteInfo } = useState<favoriteInfo>({
    favoriteName: '',
    folderName: '',
  })
  const getFavorites = useAppStore.use.getFavorites()

  useEffect(() => {
    openModal()
    return () => {
      closeModal()
    }
  }, [])

  function handleClickFavorite() {
    navigate('/planner')
    const fav = getFavorites()
    console.log('Favorite Info:', favoriteInfo, fav)
  }

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFavoriteInfo((prev) => {
      const updatedItem = { ...prev, [name]: value }
      return updatedItem
    })
  }

  return (
    <Dialog.Root defaultOpen>
      <Dialog.Portal>
        <Dialog.Content className='dialog white-background h-54 absolute left-1/2 top-1/2 z-50 w-72 -translate-x-1/2 -translate-y-1/2 rounded-2xl border-2 border-C/Color3 bg-C/Color1 p-2 text-left text-xs shadow-xl '>
          <Dialog.Title className='sr-only'>{'Opciones'}</Dialog.Title>
          <Dialog.Description className='sr-only'>{'Otros parámetros'}</Dialog.Description>
          <div className='flex flex-col items-center justify-center gap-y-1.5'>
            <p className='font-normal'>Introduzca los datos necesarios</p>
            <label className=' flex items-center'>
              Nombre favorito
              <input
                type='text'
                name='favoriteName'
                id='favoriteName'
                value={favoriteInfo?.favoriteName}
                onChange={(e) => handleInput(e)}
                className='text-md ml-2 mt-1 h-8 w-[120px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color4'
              />
            </label>
            <label className=' flex items-center'>
              Carpeta destino
              <input
                type='text'
                name='folderName'
                id='folderName'
                value={favoriteInfo?.folderName}
                onChange={(e) => handleInput(e)}
                className='text-md ml-2 mt-1 h-8 w-[120px] rounded-sm border border-solid border-C/Color4 pl-1 text-C/Color4'
              />
            </label>
            <div className='button container mb-2 flex w-full justify-center'>
              <button
                onClick={handleClickFavorite}
                className='flex cursor-pointer items-center rounded-xl border border-C/Color7 bg-C/Color3 px-3 py-0.5 text-xs font-normal text-C/Color1'
              >
                {'Ok'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
